export default "__VITE_ASSET__CZ504aGP__"